import { useState } from "react";
import { loadPersonality, savePersonality, type Personality } from "../store/drafts";

// The voice every post is written in. Stored on-device only (drafts.ts), sent as context per call,
// never stored by Oriora — and it travels in Export, so it lasts through app updates.
const FIELDS: { key: keyof Personality; label: string; placeholder: string; rows: number }[] = [
  { key: "identity", label: "Who you are / your brand", placeholder: "e.g. I'm a solo indie dev building privacy-first tools.", rows: 2 },
  { key: "tone", label: "Tone", placeholder: "e.g. casual, dry humour, no hype", rows: 1 },
  { key: "audience", label: "Audience", placeholder: "e.g. other indie devs and makers", rows: 1 },
  { key: "topics", label: "Topics you post about", placeholder: "e.g. shipping updates, lessons learned, the occasional hot take", rows: 2 },
  { key: "never_say", label: "Never say", placeholder: "e.g. no “game-changer”, no emojis, never salesy", rows: 1 },
  { key: "examples", label: "A few posts that sound like you", placeholder: "Paste 2–3 of your real posts so it matches your rhythm and style.", rows: 6 },
];

export default function PersonalityTab() {
  const [p, setP] = useState<Personality>(() => loadPersonality());
  const [saved, setSaved] = useState(false);

  function update(key: keyof Personality, value: string) {
    const next = { ...p, [key]: value };
    setP(next);
    savePersonality(next);
    setSaved(true);
  }

  return (
    <div className="wrap">
      <h2 style={{ marginTop: 0 }}>Your Personality</h2>
      <p className="note">
        This is the voice every post is written in, so it is sent with each drafting request — Oriora
        doesn&apos;t retain it. It&apos;s saved on this device and included in your Export, so it survives app
        updates; reload it anytime from the Posts tab.
      </p>
      {FIELDS.map((f) => (
        <div key={f.key} style={{ marginBottom: 14 }}>
          <label style={{ display: "block", fontSize: 13, color: "var(--ink-dim)", marginBottom: 6 }}>{f.label}</label>
          <textarea
            className="field"
            value={p[f.key] ?? ""}
            rows={f.rows}
            placeholder={f.placeholder}
            onChange={(e) => update(f.key, e.target.value)}
          />
        </div>
      ))}
      {saved && <p className="muted" style={{ fontSize: 12 }}>Saved on this device.</p>}
    </div>
  );
}
